import { Fragment } from 'react'
import _ from 'lodash'
import NextArrow from './NextArrow'

const SelectedPaths = (props) => {
  const {
    processVisible,
    className,
    selectedOptions
  } = props
  return (
    <div
      className={className}
      data-role='recent-usage'
    >
      {
        _.map(selectedOptions, (options, idx) => {
          const { disabled, className, visible } = options
          let { label } = options
          label = processVisible ? processVisible(label, visible) : label
          return (
            label && (
              <Fragment key={idx}>
                {idx !== 0 && <NextArrow />}
                <span
                  className={className}
                  disabled={disabled}
                >
                  {label}
                </span>
              </Fragment>
            )
          )
        })
      }
    </div>
  )
}

export default SelectedPaths
